module.exports = __webpack_public_path__ + "static/media/trim-lmm-o.2f5dabcf.png";